import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    cookieKey: String,
    cookieValue: String,
  };

  remember() {
    document.cookie = `${this.cookieKeyValue}=${this.cookieValueValue}; path=/; max-age=31536000; SameSite=Lax`;
  }

  dismiss() {
    this.remember();
    this.element.remove();
  }
}
